<template>
  <card>
    <div slot="header">
      <h4 class="title">Spiffs & Leads Setup</h4>
    </div>

    <div class="mb-5">
      <fg-input label="Use Incentify to:">
        <l-radio checked v-model="manageRadioValue" label="manageAndSpiff">Spiff Affiliates & Manage Leads</l-radio>
        <l-radio style="visibility: hidden" v-model="manageRadioValue" label="spiff">Spiff Affiliates</l-radio>
      </fg-input>
    </div>

    <div class="row mb-4">
      <div class="col-6">
        <fg-input label="Spiff Affiliates for:">
          <l-radio v-model="spiffRadioValue" label="spiffReceived">Leads received</l-radio>
          <l-radio v-model="spiffRadioValue" label="spiffClosed">Leads closed</l-radio>
          <l-radio v-model="spiffRadioValue" label="spiffBoth">Both</l-radio>
        </fg-input>
      </div>

      <div class="col-6">
        <div v-if="this.spiffReceivedLeads" class="col-12">
          <label>Spiff for leads received</label>
          <fg-input name="spiffReceived"
                    placeholder="$"
                    v-model="spiffForReceivedLead"
                    type="number"
                    addonRightIcon="el-icon-money">
          </fg-input>
        </div>

        <div v-if="this.spiffClosedLeads" class="col-12">
          <label>Spiff for leads closed</label>
          <div>
            <fg-input placeholder="$"
                      v-model="spiffForClosedLead"
                      type="number"
                      addonRightIcon="el-icon-money"/>
          </div>
        </div>
      </div>
    </div>

    <div>
      <label>Leads that will be tracked in Incentify:</label>
      <div>
        <i class="far mr-1"
          :class="manageLeadsMode || spiffReceivedLeads ? 'fa-check-square':'fa-square'"/>
        <small>Leads Received</small> <br>
        <i class="far mr-1"
          :class="manageLeadsMode || spiffClosedLeads ? 'fa-check-square':'fa-square'"/>
        <small>Leads Closed</small> <br>
        <i class="far mr-1"
          :class="manageLeadsMode ? 'fa-check-square' : 'fa-square'"/>
        <small>Leads Lost</small> <br>
      </div>
    </div>

    <br>

    <!-- <template v-if="welcomeSpiffActive"> -->
    <template v-if="true">
      <div class="row">
        <div class="col-6">
          <label>Default Welcome Spiff</label>
          <fg-input name="welcomeSpiff"
                    placeholder="$"
                    v-model="welcomeSpiff"
                    type="number"
                    required
                    addonRightIcon="el-icon-money">

          </fg-input>
        </div>
      </div>
    </template>

    <br>
    <br>
    
    <div class="text-center">
      <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="save()">
        {{ buttonLabel }}
      </button>
    </div>
    <div class="clearfix"></div>
  </card>
</template>

<script>
export default {
  name: 'Spiffs-Leads-Setup',
  data() {
    return {
      // manageLeadsMode: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.manageLeadsMode : null,
      manageLeadsMode: true, // TMP
      spiffReceivedLeads: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.spiffReceivedLeads : null,
      spiffForReceivedLead: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.spiffForReceivedLead : null,
      spiffClosedLeads: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.spiffClosedLeads : null,
      spiffForClosedLead: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.spiffForClosedLead : null,
      welcomeSpiff: this.$store.getters.spiffsLeadsSetup ? this.$store.getters.spiffsLeadsSetup.welcomeSpiff || 0 : 0,
      // welcomeSpiffActive: !process.env.VUE_APP_WELCOME_SPIFF_ACTIVE || (process.env.VUE_APP_WELCOME_SPIFF_ACTIVE == 'true')
      // welcomeSpiffActive: process.env.VUE_APP_WELCOME_SPIFF_ACTIVE == 'true'
    }
  },
  computed:  {
    manageRadioValue: {
      get () { return this.manageLeadsMode == null || this.manageLeadsMode == undefined ? '' : (this.manageLeadsMode ? 'manageAndSpiff' : 'spiff') },
      set (value) { this.manageLeadsMode = (value === 'manageAndSpiff' ? true : false) }
    },
    spiffRadioValue: {
      get () {
        switch (this.spiffReceivedLeads) {
          case true:
            //console.log('case true')
            return this.spiffClosedLeads ? 'spiffBoth' : 'spiffReceived'
            break
          case false:
            //console.log('case false')
            return 'spiffClosed'
            break
          default:
            return ''
            break
        }
      },
      set (value) {
        switch (value) {
          case 'spiffReceived':
            this.spiffClosedLeads = false
            this.spiffReceivedLeads = true
            break
          case 'spiffClosed':
            this.spiffReceivedLeads = false
            this.spiffClosedLeads = true
            break
          case 'spiffBoth':
            this.spiffClosedLeads = true
            this.spiffReceivedLeads = true
            break
          default:
            break
        }
      }
    },
    buttonLabel () {
      // return this.$store.getters.isAffiliateCompaniesSetupComplete ? 'Save' : 'Save & Next'
      return 'Save'
    },
  },
  methods: {
    async save () {
      try {
        const spiffsLeadsSetup = { manageLeadsMode: this.manageLeadsMode,
                                   spiffReceivedLeads: this.spiffReceivedLeads,
                                   spiffForReceivedLead: this.spiffForReceivedLead ? Number(this.spiffForReceivedLead) : null,
                                   spiffClosedLeads: this.spiffClosedLeads,
                                   spiffForClosedLead: this.spiffForClosedLead ? Number(this.spiffForClosedLead) : null,
                                   welcomeSpiff: Number(this.welcomeSpiff) || 0 }
        // console.log('<><><><><> save(), spiffLeadsSetup = ', spiffsLeadsSetup)
        const res = await this.$store.dispatch('saveSpiffsLeadsSetup', spiffsLeadsSetup)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Saved!'})
          this.$store.commit('SAVE_SPIFFS_LEADS_SETUP', spiffsLeadsSetup.spiffsLeadsSetup)
          await this.$store.dispatch('fetchBaseData')
          this.$router.push('/admin/home')
        }
      }
      catch (e) {
        this.$notify({errorMessage: e.message || (e.errors?e.errors[0]:'problem while trying to save.')})
      }
    }
  }
}
</script>

<style>

</style>